module.exports = __webpack_public_path__ + "img/productActive-1.c10ad799.svg";